import React from 'react';

import styles from '../config/styles';
import { withStyles, Typography } from '../../node_modules/@material-ui/core';

class Status extends React.Component{
    render(){
        const {classes} = this.props;
        return(
            <section className={[classes.section, classes.status, classes.centered].join(" ")}>
                <Typography variant="caption">
                    {this.props.statusUpdate}
                </Typography>
            </section>
        )
    }
}

export default withStyles(styles)(Status);